export default "__VITE_ASSET__L9pCziCu__"